import {hitGoogleTagManager} from "../../../../tracking/google_tag_manager/hit_google_tag_manager";
import {IGTMEcommerce} from "../../../../tracking/types/ecommerce/IGTMEcommerce";
import {IGTMEcommerceItem} from "../../../../tracking/types/ecommerce/IGTMEcommerceItem";
import {getGtmEcommerceOfferItemBaseProps, IGtmEcommerceOfferItemBaseProps} from "../common/get_gtm_ecommerce_offer_item_base_props";

export interface IHitGTMOfferViewItemListParams {
    offers: IGtmEcommerceOfferItemBaseProps[];
    listId: string;
    listName: string;
}

export const hitGTMOfferViewItemList = (params: IHitGTMOfferViewItemListParams) => {
    const items: IGTMEcommerceItem[] = params.offers.map((offer, index) => ({
        ...getGtmEcommerceOfferItemBaseProps(offer),
        item_category: "investment",
        index: index + 1
    }));

    const ecommerce: IGTMEcommerce = {
        item_list_id: params.listId,
        item_list_name: params.listName,
        items
    };

    hitGoogleTagManager({
        event: "view_item_list",
        ecommerce
    });
};
